// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n-AddToAllProjects__label {
  pointer-events: all;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/user-management/management/ui/AddToAllProjects.less"],"names":[],"mappings":"AACE;EAEE,mBAAA;AADJ","sourcesContent":[".n-AddToAllProjects {\n  &__label {\n    // enable pointer events to allow showing tooltip for a disabled checkbox\n    pointer-events: all;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
